<template>
  <div class="purse">
    <span class="purse__yours" data-tut="purse-mine" :style="{ '--role': colour }">
      <!-- The Hall's workers are its cards (2026-10-14): during the day its
           first pip is cards in hand, since its workers were dealt away. -->
      <Pip :kind="role === 'trade' ? 'shifts' : (role === 'military' ? 'actions' : (role === 'culture' && !dawn ? 'cards' : 'workers'))" :n="workers" />
      <!-- Said, not just drawn (playtest 9: "what's the number on the top left?"). -->
      <span class="purse__left">{{ dawn ? (role === 'trade' ? 'shifts given' : (role === 'military' ? 'actions given' : 'given')) : (role === 'trade' ? 'shifts' : (role === 'military' ? 'actions' : (role === 'culture' ? 'in hand' : 'left'))) }}</span>
    </span>
    <span class="purse__pools">
      <Pip v-for="k in POOLS" :key="k" :kind="k" :n="civ[k] || 0" />
    </span>
    <span class="purse__tracks">
      <Pip v-for="k in TRACKS" :key="k" :kind="k" :n="civ[k] || 0" />
    </span>
  </div>
</template>

<script>
import { ROLE_INFO } from '@/engine/constants';
import Pip from './Pip.vue';

// What you have, in the same icons the cards spend. Matt: "Anything that I
// could spend on cards needs to be visible on this screen... I can glance at
// the top and see what my current resources are."
//
// The first pip is YOURS - the workers this role was given at dawn, in the
// role's colour. The rest is the common purse: one town, one pot.
const POOLS = ['food', 'goods', 'coin', 'knowledge'];
const TRACKS = ['population', 'happiness'];

export default {
  name: 'PurseStrip',
  components: { Pip },
  props: {
    // At dawn the number is what this role is being GIVEN, not what is left.
    dawn: { type: Boolean, default: false },
    civ: { type: Object, required: true },
    workers: { type: Number, default: 0 },
    role: { type: String, default: null },
  },
  data() { return { POOLS, TRACKS }; },
  computed: {
    colour() { return ROLE_INFO[this.role]?.colour || 'var(--accent)'; },
  },
};
</script>
